'use strict';

const gtm = require('../modules/google').tagManager;
const QRcode = require('qrcode');
const isTouchDevice = require('../modules/helpers/isTouchDevice');
const getUpdatedURLWithParams = require('../modules/util/getUpdatedURLWithParams');

const pushEvent = (eventAction, eventCategory) => {

    const eventLabel = $('.js-the-ritual-of-title').first().text().trim();

    if (!eventAction) {
        return;
    }

    const event = {
        event: 'easter',
        event_category: eventCategory ? eventCategory : 'pdp', /* eslint-disable-line camelcase */
        event_action: eventAction, /* eslint-disable-line camelcase */
        event_label: eventLabel /* eslint-disable-line camelcase */
    };

    gtm.pushDataLayerEvent(event);
};

const init = () => {

    bindEvents();

    const $modelViewers = $('.js-egg-model-viewer');
    if (!$modelViewers || !$modelViewers.length) {
        removeAndHideElements();
        return;
    }

    if (!$modelViewers[0].canActivateAR) {
        removeAndHideElements(true);
        return;
    }

    if (new URL(window.location.href).searchParams.get('triggerARMode') == 'true') {
        $modelViewers[0].activateAR();
    }

    $modelViewers.on('click', (e) => {
        const $this = $(e.target).closest('.js-easter-ar-block-wrapper');
        pushEvent($this && $this.length ? 'content view in 3D' : 'main view in 3d');
    });

    $modelViewers.on('ar-status', (e) => {
        if (e.detail.status === 'failed') {
            removeAndHideElements(true);
        }
    });

    $modelViewers.on('error', () => {
        removeAndHideElements(true);
    });
};

const removeAndHideElements = (removeElements) => {
    if (removeElements) {
        $('.js-easter-view-block-ar').remove();
        $('.js-egg-model-viewer').remove();
    }

    $('.js-easter-view-block').removeClass('hide');

    if (removeElements) {
        bindEvents();
    }
};

const bindEvents = () => {

    $(document).on('click', '.js-easter-link-whatsapp', () => {
        pushEvent('whatsapp');
    });

    $(document).on('click', '.js-easter-link-messenger', () => {
        pushEvent('messenger');
    });

    $(document).off('click.easter', '.js-easter-ar-button').on('click.easter', '.js-easter-ar-button',(e) => {
        const $this = $(e.target);
        const popupData = $this.data('popup-data');
        if (!popupData) {
            return;
        }

        const $modelViewers = $('.js-egg-model-viewer');

        if (!isTouchDevice() || !$modelViewers || !$modelViewers.length || !$modelViewers[0].canActivateAR) {
            QRcode.toDataURL(getUpdatedURLWithParams({triggerARMode: true, skipAnimation: true}, ['skipAnimation'], true), {width: 180})
            .then(QRcodeURL => {
                arView.show(popupData, QRcodeURL, $this);
            });
            return;
        }
    });
};

const arView = {
    show: (data, QRcodeURL, taget) => {
        const $this = $(taget).closest('.js-easter-ar-block-wrapper');
        pushEvent($this && $this.length ? 'content view in 3D' : 'main view in 3d');
        window.eventBus.$emit('shouldOpenModal', {
            resources: {
                heading: data.header,
                description: data.description
            },
            closeElement: {
                eventName: 'onCloseElementClick',
                shouldCloseModal: true
            },
            ctaHolder: {},
            easterModal: true,
            icon: data.icon,
            QRcodeURL: QRcodeURL
        });
    }
};

const updateARbuttons = (src, iosSrc, description) => {
    if (!src || !iosSrc || !description) {
        return;
    }
    const $element = $('.js-easter-ar-button');
    if (!$element || !$element.length) {
        return;
    }
    const popupData = $element.data('popup-data');
    if (!popupData) {
        return;
    }
    popupData.src = src;
    popupData.iosSrc = iosSrc;
    popupData.description = description;

    $element.attr('data-popup-data', JSON.stringify(popupData));
};

const updateARmodel = (src, iosSrc) => {
    if (!src || !iosSrc) {
        return;
    }
    const $element = $('.js-egg-model-viewer');
    if (!$element || !$element.length) {
        return;
    }

    $element.attr('src', src);
    $element.attr('ios-src', iosSrc);
};

const pushDataLayerDataForFAQBlock = (questionText) => {
    const isEasterPDP = $('.js-easter-pdp').length;
    if (isEasterPDP && questionText) {
        pushEvent(questionText);
    }
};


module.exports = {
    init: init,
    updateARbuttons: updateARbuttons,
    updateARmodel: updateARmodel,
    pushEvent: pushEvent,
    pushDataLayerDataForFAQBlock
};
